import { CardReasonModel } from '../interfaces';
import { PenaltyReason, PenaltyType } from '@core-http';

export const cardIconMapper: Record<PenaltyType, string> = {
  [PenaltyType.RED]: 'assets/icons/red-card.svg',
  [PenaltyType.YELLOW]: 'assets/icons/yellow-card.svg'
};

export const cardReasonMapper: Record<PenaltyReason, CardReasonModel> = {
  [PenaltyReason.ABSENCE]: {
    value: PenaltyReason.ABSENCE,
    displayName: 'Nieobecność zawodnika',
    icon: cardIconMapper[PenaltyType.RED],
    cardType: PenaltyType.RED
  },
  [PenaltyReason.NOT_PAID]: {
    value: PenaltyReason.NOT_PAID,
    displayName: 'Brak płatności za gierkę',
    icon: cardIconMapper[PenaltyType.RED],
    cardType: PenaltyType.RED
  },
  [PenaltyReason.LEAVING_30_MIN]: {
    value: PenaltyReason.LEAVING_30_MIN,
    displayName: 'Opuszczenie gierki 30 min przed',
    icon: cardIconMapper[PenaltyType.YELLOW],
    cardType: PenaltyType.YELLOW
  },
  [PenaltyReason.LATE_15_MIN]: {
    value: PenaltyReason.LATE_15_MIN,
    displayName: 'Spóźnienie powyżej 15 minut',
    icon: cardIconMapper[PenaltyType.YELLOW],
    cardType: PenaltyType.YELLOW
  },
  [PenaltyReason.MISMATCHED_LEVEL]: {
    value: PenaltyReason.MISMATCHED_LEVEL,
    displayName: 'Niedopasowany poziom zawodnika do poziomu gierki',
    icon: cardIconMapper[PenaltyType.YELLOW],
    cardType: PenaltyType.YELLOW
  },
  [PenaltyReason.UNSPORTSMANLIKE_BEHAVIOR]: {
    value: PenaltyReason.UNSPORTSMANLIKE_BEHAVIOR,
    displayName: 'Niesportowe zachowanie',
    icon: cardIconMapper[PenaltyType.YELLOW],
    cardType: PenaltyType.YELLOW
  }
};
